module.exports = __webpack_public_path__ + "assets/img/mask-character-long.81db691e.png";